export default __webpack_public_path__ + "static/media/comp.a0cfacfe.png";